/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetCurrentUserQueryResponse, GetCurrentUser400, GetCurrentUser401, GetCurrentUser403, GetCurrentUser404, GetCurrentUser409, GetCurrentUser500 } from "../../types/userController/GetCurrentUser.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getCurrentUser } from "../../client/userController/getCurrentUser.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getCurrentUserQueryKey = () => [{ url: '/api/users/me' }] as const

export type GetCurrentUserQueryKey = ReturnType<typeof getCurrentUserQueryKey>

export function getCurrentUserQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getCurrentUserQueryKey()
        return queryOptions<GetCurrentUserQueryResponse, ResponseErrorConfig<GetCurrentUser400 | GetCurrentUser401 | GetCurrentUser403 | GetCurrentUser404 | GetCurrentUser409 | GetCurrentUser500>, GetCurrentUserQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getCurrentUser({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get current user profile
 * {@link /api/users/me}
 */
export function useGetCurrentUser<TData = GetCurrentUserQueryResponse, TQueryData = GetCurrentUserQueryResponse, TQueryKey extends QueryKey = GetCurrentUserQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetCurrentUserQueryResponse, ResponseErrorConfig<GetCurrentUser400 | GetCurrentUser401 | GetCurrentUser403 | GetCurrentUser404 | GetCurrentUser409 | GetCurrentUser500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getCurrentUserQueryKey()
         

         const query = useQuery({
          ...getCurrentUserQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetCurrentUser400 | GetCurrentUser401 | GetCurrentUser403 | GetCurrentUser404 | GetCurrentUser409 | GetCurrentUser500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}